"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitSurveyStep = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const ui_platform_http_1 = require("@forto-dev/ui-platform-http");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const LoggerContext_1 = require("../../../lib/LoggerContext");
const useSubmitSurveyStepAPI = () => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    return (body) => {
        const url = `${config.NOTIFICATION_CENTER_ENDPOINT}/v2/surveys/submit`;
        return ui_platform_http_1.HttpBaseApi.put(url, body, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
    };
};
const useSubmitSurveyStep = () => {
    const submitSurveyStepAPI = useSubmitSurveyStepAPI();
    const { logError, logInfo } = (0, LoggerContext_1.useLoggerContext)();
    return (0, frontend_infra_reactquery_1.useMutation)({
        mutationKey: ['submitSurveyStep'],
        mutationFn: submitSurveyStepAPI,
        onSuccess: async (_data) => {
            logInfo('Survey step submit succeeded');
        },
        onError: (err, _body) => {
            logError(`Survey step submit Failed: ${err?.message}`);
        },
    });
};
exports.useSubmitSurveyStep = useSubmitSurveyStep;
//# sourceMappingURL=useSubmitSurveyStep.js.map